import script from "./VSTabla.vue?vue&type=script&setup=true&lang=js"
export * from "./VSTabla.vue?vue&type=script&setup=true&lang=js"

import "./VSTabla.vue?vue&type=style&index=0&id=b4558130&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4558130"]])

export default __exports__